const apiRouting = {
  apiAddess: process.env.REACT_APP_API_ROUTE,
};


export default apiRouting;
